import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaAngleUp, FaAngleDown, FaAngleLeft, FaAngleRight } from "react-icons/fa";
import DashboardNavData from "./ManagerDashboardNavData.js";

const ManagerDashboardNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [openDropdown, setOpenDropdown] = useState(null);
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        document.documentElement.style.setProperty(
            "--manager-nav-width",
            collapsed ? "80px" : "250px"
        );
    }, [collapsed]);

    const handleDropdown = (value, key) => {
        if (collapsed) {
            setCollapsed(false);
            return;
        }; // 折り畳み時はドロップダウン無効 
        if (value.dropdown) {
            setOpenDropdown(openDropdown === key ? null : key);
        } else {
            navigate(value.link);
        }
    };

    const isActive = (value) => {
        if (value.link && location.pathname === value.link) return true;
        if (value.dropdown) {
            return value.dropdown.some(item => location.pathname === item.link);
        }
        return false;
    };

    return (
        <div className={`manager-nav ${collapsed ? "collapsed" : ""}`}>

            <button
                className="nav-toggle"
                onClick={() => {
                    setCollapsed(!collapsed);
                    setOpenDropdown(null); // 折り畳み時にドロップダウンを閉じる
                }}
                aria-label="Toggle navigation"
                style={{
                    width: "20px",
                    height: "20px",
                    minWidth: "20px",
                    minHeight: "20px",
                    borderRadius: "50%",
                    padding: "0",
                    backgroundColor: "var(--cream)",
                    color: "var(--dark)",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    alignSelf: collapsed ? "center" : "flex-end",
                    margin: collapsed ? "12px 0 0 0" : "12px 12px 0 0",
                    cursor: "pointer",
                    fontSize: "14px",
                    position: "absolute",
                    left: collapsed ? "0" : "230px"
                }}
            >
                {collapsed ? <FaAngleRight /> : <FaAngleLeft />}
            </button>
            <div className="manager-nav-inner">
                <div className="nav-logo">
                    <img
                        src="/images/logo-circle-white.png"
                        alt="logo"
                        style={{ width: collapsed ? 40 : 100, height: collapsed ? 40 : 100 }}
                    />
                </div>
            </div>
            <ul className="nav_list">
                {DashboardNavData.map((value, key) => (
                    <li key={key} className={`list ${isActive(value) ? "active" : ""}`}>                        <div
                        className="row"
                        onClick={() => handleDropdown(value, key)}
                    >
                        {collapsed && <div className="nav-icon">{value.icon}</div>}
                        {!collapsed && <div className="nav-title">{value.title}</div>}
                        {!collapsed && value.dropdown && (
                            openDropdown === key ? <FaAngleUp /> : <FaAngleDown />
                        )}
                    </div>

                        {!collapsed && value.dropdown && openDropdown === key && (<ul className="dropdown-list">
                            {value.dropdown.map((item, i) => (
                                <li
                                    key={i}
                                    className={`dropdown-item ${location.pathname === item.link ? "active" : ""}`} onClick={() => navigate(item.link)}
                                >
                                    {item.title}
                                </li>
                            ))}
                        </ul>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ManagerDashboardNav;